<template>
  <perfect-scrollbar
    v-bind="{...$props, ...$attrs}"
    :class="{
      'always-show-y': alwaysShowY,
      'always-show-x': alwaysShowX,
    }"
    v-on="$listeners"
  >
    <slot></slot>
  </perfect-scrollbar>
</template>

<script>
import {PerfectScrollbar} from 'vue2-perfect-scrollbar'

export default {
  name: 'ZScrollbar',
  components: {
    PerfectScrollbar,
  },
  props: {
    alwaysShowY: {
      type: Boolean,
      default: false,
    },

    alwaysShowX: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css" />
<style scoped lang="scss">
:deep(.ps__thumb-y) {
  background-color: var(--black-100);
}

:deep(.ps__thumb-x) {
  background-color: var(--black-100);
}

.always-show-y {
  :deep(.ps__rail-y) {
    opacity: 1 !important;
  }
}

.always-show-x {
  :deep(.ps__rail-x) {
    opacity: 1 !important;
  }
}
</style>
